import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ApiClient from "../../API/ApiClient";
const SpinningCubePopup = () => {
  const popupRef = useRef(null);
  const cubeRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [velocity, setVelocity] = useState({ x: 0, y: 0 });
  const [resetKey, setResetKey] = useState(0); // to force useEffect update
  const lastPos = useRef({ x: 0, y: 0 });
  const animationFrame = useRef(null);
  const resetTimeout = useRef(null);
  const didDrag = useRef(false);

  const { getRequestApi } = ApiClient();

  const { language = "en" } = useParams();

  const [loadData, setLoadData] = useState([]);
  const loadPreLoadData = async () => {
    try {
      const response = await getRequestApi(`post/type/Cube/${language}`);
      setLoadData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    loadPreLoadData();
  }, [language]);
  const friction = 0.95;

  // 🖱️ Mouse down: start drag
  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    didDrag.current = false;
    cancelAnimationFrame(animationFrame.current);
    clearTimeout(resetTimeout.current);
    lastPos.current = { x: e.clientX, y: e.clientY };
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    applyInertia();

    clearTimeout(resetTimeout.current);
    resetTimeout.current = setTimeout(() => {
      cancelAnimationFrame(animationFrame.current); // 👈 cancel inertia before resetting
      setRotation({ x: 0, y: 0 });
      setResetKey((prev) => prev + 1); // force re-render
    }, 3000);
  };

  // 🖱️ Mouse move: apply rotation + calculate velocity
  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - lastPos.current.x;
    const dy = e.clientY - lastPos.current.y;

    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
      didDrag.current = true; // ← Mark it as drag
    }

    lastPos.current = { x: e.clientX, y: e.clientY };

    setRotation((prev) => ({
      x: prev.x + dy * 0.5,
      y: prev.y + dx * 0.5,
    }));

    setVelocity({ x: dy * 0.5, y: dx * 0.5 });
  };
  const handleClick = (e) => {
    if (didDrag.current) {
      e.preventDefault(); // ← Prevent navigation
      e.stopPropagation();
    }
  };

  // 🌀 Smooth inertia rotation using velocity decay
  const applyInertia = () => {
    let vx = velocity.x;
    let vy = velocity.y;

    const animate = () => {
      vx *= friction;
      vy *= friction;

      setRotation((prev) => ({
        x: prev.x + vx,
        y: prev.y + vy,
      }));

      if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
        animationFrame.current = requestAnimationFrame(animate); // 👈 store frame ID
      }
    };

    animationFrame.current = requestAnimationFrame(animate); // 👈 initial call
  };

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(animationFrame.current);
      clearTimeout(resetTimeout.current);
    };
  }, [handleMouseMove]);
  useEffect(() => {
    if (cubeRef.current) {
      cubeRef.current.style.transform = `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`;
    }
  }, [rotation, resetKey]); //

  return (
    <div className="cube-popup-overlay">
      <div className="cube-popup-content" ref={popupRef}>
        <div id="scene">
          {/* <div id="cube" className="assembly cube" ref={cubeRef}>
                        <div className="face">
                            <a href="https://iffigoa.org/festival/?utm_source=nfdc&utm_medium=cube&utm_campaign=ip" className="stretched-link" aria-label='Ip-Link'>
                                <img src="https://iffigoa.org/public/images/ip.jpg" alt="Face-1" />
                            </a>
                        </div>
                        <div className="face">
                            <a href="https://iffigoa.org/festival/?utm_source=nfdc&utm_medium=cube&utm_campaign=ip" className="stretched-link" aria-label='Ip-Link'>
                                <img src="https://iffigoa.org/public/images/ip.jpg" alt="Face-6" />
                            </a>
                        </div>
                        <div className="face">
                            <a href="https://iffigoa.org/festival?utm_source=nfdc&utm_medium=cube&utm_campaign=ott" className="stretched-link" aria-label='Ott-Link'>
                                <img src="https://iffigoa.org/public/images/OTT-open.jpg" alt="Face-3" />
                            </a>
                        </div>
                        <div className="face">
                            <a href="https://films.wavesbazaar.com/programme/screenwriters-lab/features/?utm_source=nfdc&utm_medium=cube&utm_campaign=swl" className="stretched-link" aria-label='Waves-Link'>
                                <img src="/assets/images/waves-bazaar.jpg" alt="Face-4" />
                            </a>
                        </div>
                        <div className="face">
                            <a href="https://iffigoa.org/festival/?utm_source=nfdc&utm_medium=cube&utm_campaign=ip" className="stretched-link" aria-label='Ip-Link'>
                                <img src="https://iffigoa.org/public/images/IP_Free.jpg" alt="Face-2" />
                            </a>
                        </div>
                        <div className="face">
                            <a href="https://iffigoa.org/festival?utm_source=nfdc&utm_medium=cube&utm_campaign=ott" className="stretched-link" aria-label='Ott-Link'>
                                <img src="https://iffigoa.org/public/images/OTT-open.jpg" alt="Face-5" />
                            </a>
                        </div>
                    </div> */}
          <div id="cube" className="assembly cube" ref={cubeRef}>
            {loadData
              ?.slice()
              .reverse()
              .map((item, index) => (
                <div className="face" key={item.id}>
                  <a
                    href={item.post_meta?.ext_link}
                    //className="stretched-link"
                    aria-label={`${item.title}`}
                  >
                    <img src={item.post_meta?.image_url} alt={item.title} />
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default SpinningCubePopup;
